import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#437A84',
    },
    secondary: {
      main: '#00D9FF',
    },
    background: {
      default: '#001A1F',
      paper: '#002A33',
    },
    text: {
      primary: '#E0F0F4',
      secondary: '#A0C4CC',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica Neue", Arial, sans-serif',
    h1: {
      fontFamily: '"Londrina Shadow", cursive',
      fontWeight: 400,
    },
    h2: {
      fontFamily: '"Caveat", cursive',
      fontWeight: 700,
    },
    h3: {
      fontFamily: '"Caveat", cursive',
      fontWeight: 600,
    },
    h4: {
      fontFamily: '"Caveat", cursive',
      fontWeight: 600,
    },
    subtitle1: {
      fontFamily: '"Roboto Condensed", "Arial Narrow", sans-serif',
    },
    subtitle2: {
      fontFamily: '"Roboto Condensed", "Arial Narrow", sans-serif',
    },
    body1: {
      fontFamily: '"Roboto", "Helvetica Neue", Arial, sans-serif',
      fontSize: '1rem',
    },
    body2: {
      fontFamily: '"Roboto", "Helvetica Neue", Arial, sans-serif',
      fontSize: '0.875rem',
    },
    caption: {
      fontFamily: '"Roboto Condensed", "Arial Narrow", sans-serif',
      fontSize: '0.75rem',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
  },
});

export default theme;
